import { Injectable } from '@angular/core';
import { ServerErrorCodes } from '../../../assets/data/server-error-codes.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  constructor() {}

  getErrorMessage(serverMessage: any) {
    serverMessage = serverMessage?.error ?? serverMessage;

    if (typeof serverMessage === 'string') {
      let errorHtml = '';
      const errorCodes = Object.keys(
        ServerErrorCodes
      ) as (keyof typeof ServerErrorCodes)[];

      let errorMessageCodes = this.getErrorMessageCodes(serverMessage);

      for (let errorMessageCode of errorMessageCodes) {
        errorMessageCode = errorMessageCode
          .replace(/[\s:]+/g, '')
          .toUpperCase();

        for (const errorCode of errorCodes) {
          if (errorMessageCode.includes(errorCode)) {
            let errorCodeArr: string = errorCode; // Explicitly define as string
            let extraData: string[] = []; // Explicitly define as an array of strings

            if (errorMessageCode.includes('??')) {
              const parts: string[] = errorMessageCode.split('??'); // Split into a string array
              errorCodeArr = parts[0]; // The first part is the error code
              extraData = parts.slice(1); // The rest is extra data

              console.log('Extracted errorCode:', errorCodeArr);
              console.log('Extra data:', extraData);
            }

            // Retrieve the error message template and replace placeholders
            let errorMessage: string =
              ServerErrorCodes[errorCodeArr as keyof typeof ServerErrorCodes] ||
              'Unknown error';

            // Replace placeholders like {0}, {1} with values from extraData
            errorMessage = errorMessage.replace(
              /{(\d+)}/g,
              (match: string, index: string) => {
                const idx = parseInt(index, 10); // Convert index to a number
                return extraData[idx] !== undefined ? extraData[idx] : match; // Replace or keep original placeholder
              }
            );

            // Append the final error message to errorHtml
            errorHtml += `<li>${errorMessage}</li>`;
          }
        }
      }

      if (errorHtml.length > 0) {
        errorHtml = `<ol>${errorHtml}</ol>`;
      }

      if (errorHtml === '') {
        return ServerErrorCodes.GENERIC_ERROR;
      }

      return errorHtml;
    }

    return 'Προέκυψε ένα απροσδιόριστο σφάλμα. Παρακαλώ επικοινωνήστε με τον διαχειριστή της εφαρμογής.';
  }

  private getErrorMessageCodes(serverMessage: string) {
    let errorMessageCodes: string[] = [];
    if (serverMessage.indexOf('|')) {
      errorMessageCodes = serverMessage.split('|');
    } else {
      errorMessageCodes.push('serverMessage');
    }
    return errorMessageCodes;
  }
}
